<script>
	import {
		Modal,
		ModalBody,
		ModalHeader,
		ModalFooter,
	} from "@sveltestrap/sveltestrap";
	import CustomButton from "../CustomButton/CustomButton.svelte";
	import { versionModalOpen } from "src/store/store";

	const toggle = () => versionModalOpen.set(false);
</script>

<Modal isOpen={$versionModalOpen} backdrop centered {toggle}>
	<ModalHeader><b>About</b></ModalHeader>
	<ModalBody
		><b>Version number:</b> fms-web-{import.meta.env.APP_VERSION}</ModalBody
	>
	<ModalFooter>
		<CustomButton buttonText="Ok" color="custom-blue" on:click={toggle} />
	</ModalFooter>
</Modal>
